var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"stars",style:(("\n      --highlightedPercentage: " + (_vm.$options.methods.highlightedPercentage(
        _vm.props.rating
      )) + "%;\n      --maxStars: '" + (_vm.$options.methods.maxStars()) + "';\n    "))})}
var staticRenderFns = []

export { render, staticRenderFns }